var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5C25 11.8882 24.1819 9.34202 22.6606 7.21903C21.1393 5.09604 18.9912 3.50291 16.518 2.66337C14.0448 1.82384 11.3708 1.78008 8.87144 2.53825C6.37211 3.29641 4.17304 4.81841 2.58308 6.89048C0.993125 8.96256 0.0921482 11.4806 0.00669267 14.091C-0.0787629 16.7014 0.655595 19.273 2.10663 21.4446C3.55766 23.6163 5.65248 25.2788 8.09687 26.1988C10.5413 27.1188 13.2124 27.2501 15.7352 26.5741",
    stroke: "#EE2D2F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5009,
    cy: 14.5,
    r: 5.55556,
    stroke: "#EE2D2F",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0547 10.3334V16.5834C18.0547 18.501 19.6093 20.0556 21.5269 20.0556V20.0556C23.4446 20.0556 24.9991 18.501 24.9991 16.5834V14.5",
    stroke: "#EE2D2F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtIcon);
export default __webpack_public_path__ + "static/media/at_icon.940a501e.svg";
export { ForwardRef as ReactComponent };